import { Grid, Text, Stack, Divider, NumberFormatter } from '@mantine/core';
import { CommonHash, Line } from '@types';
import { calculateLineDiscount } from '../../form/formUtils';
import { REFERENCEDOCUMENTSOPTIONS } from '@constants';
import styles from './DrawerPrevisualization.module.scss';

function Lines({ document }: { document: CommonHash }) {
  return (
    <Stack mt={40} gap="0">
      <Grid>
        <Grid.Col span={1} py={0}>
          <Text fw={800} fz={12}>
            Item
          </Text>
        </Grid.Col>
        <Grid.Col span={3} py={0}>
          <Text fw={800} fz={12}>
            Detalle
          </Text>
        </Grid.Col>
        <Grid.Col span={2} py={0}>
          <Text fw={800} fz={12}>
            Cantidad
          </Text>
        </Grid.Col>
        {document.type !== 'ElectronicSettlement' ? (
          <>
            <Grid.Col span={2} py={0}>
              <Text fw={800} fz={12}>
                Precio $
              </Text>
            </Grid.Col>
            <Grid.Col span={2} py={0}>
              <Text fw={800} fz={12}>
                Dcto $
              </Text>
            </Grid.Col>
          </>
        ) : (
          <Grid.Col span={4} py={0}>
            <Text fw={800} fz={12}>
              Tipo doc.
            </Text>
          </Grid.Col>
        )}
        <Grid.Col span={2} py={0}>
          <Text fw={800} fz={12}>
            Monto $
          </Text>
        </Grid.Col>
      </Grid>
      <Divider color="black" my={10} />
      <Grid>
        {document?.lines_attributes.map((line: Line, index: number) => {
          const discount = calculateLineDiscount(line.amount, line.quantity, line.discount) || 0;
          const code = () => {
            let text = '';
            if (line.code_type !== null && line.code_type !== undefined && line.code_type !== '') {
              text += `${line.code_type}-`;
            }
            if (line.code !== null && line.code !== undefined && line.code !== '') {
              text += line.code;
            }
            return text;
          };
          return (
            <>
              <Grid.Col span={1} py={0} mb={20}>
                <Text fz={12}>
                  {line.code !== null && line.code !== undefined && line.code !== ''
                    ? code()
                    : index + 1}
                </Text>
              </Grid.Col>
              <Grid.Col span={3} py={0}>
                <Text fz={12}>{line.name}</Text>
                <Text fz={9} className={styles.description}>
                  {line.description}
                </Text>
              </Grid.Col>
              <Grid.Col span={2} py={0}>
                <Text fz={12}>
                  <NumberFormatter
                    thousandSeparator="."
                    decimalSeparator=","
                    value={line.quantity}
                  />
                </Text>
              </Grid.Col>
              {document.type !== 'ElectronicSettlement' ? (
                <>
                  <Grid.Col span={2} py={0}>
                    <Text fz={12}>
                      <NumberFormatter
                        thousandSeparator="."
                        decimalSeparator=","
                        value={line.amount}
                      />
                    </Text>
                  </Grid.Col>
                  <Grid.Col span={2} py={0}>
                    <Text fz={12}>
                      <NumberFormatter
                        thousandSeparator="."
                        decimalSeparator=","
                        value={discount}
                      />
                    </Text>
                  </Grid.Col>
                </>
              ) : (
                <Grid.Col span={4} py={0}>
                  <Text fz={12}>
                    {REFERENCEDOCUMENTSOPTIONS.find(
                      (option) => option.value === line.reference_kind,
                    )?.label.split('-')[1] || (line.reference_kind as string)}
                  </Text>
                </Grid.Col>
              )}
              <Grid.Col span={2} py={0}>
                <Text fz={12}>
                  <NumberFormatter
                    thousandSeparator="."
                    decimalSeparator=","
                    value={line.total_amount}
                  />
                </Text>
              </Grid.Col>
            </>
          );
        })}
      </Grid>
    </Stack>
  );
}

export default Lines;
